import "./style.scss";
import { useSubFooter } from "./hooks";
import { useElement, useLocale } from "../../../hooks";

export const SubFooter = () => {
  const { t } = useLocale();
  const Link = useElement("Link");
  const { service } = useSubFooter();
  const searches = [
      "Car Service In Jaipur",
      "Car Mechanic In Jaipur",
      "Car Workshop In Jaipur",
      "Car Repair In Jaipur",
      "Car Wash In Jaipur",
      "Car Denting & Painting Services In Jaipur",
      "Engine Oil Filter Service In Jaipur",
      "Car Wheel Alignment In Jaipur",
      "Car Parts & Repairs Service In Jaipur",
      "Car AC Service In Jaipur",
      "Car Dry Clean in Jaipur",
      "Car Tyre Shops In Jaipur",
      "Car Wheel Balancing In Jaipur",
      "Car Detailing Service in Jaipur",
      "Car Coating in Jaipur",
      "Car Rubbing & Polishing In Jaipur",
    ],
    society = [
      { url: "/services", label: "Car Service near ROYAL AVENUE SOCIETY" },
      { url: "/services", label: "Car Service near KRISHNA KUNJ VILAS" },
      { url: "/services", label: "Car Service near ABL SKY TERRACE" },
      { url: "/services", label: "Car Service near Mangalam City" },
      {
        url: "/services",
        label: "Car Service near Shakambharis Kohinoor Residency",
      },
      { url: "/services", label: "Car Service near Dwarka Apartments" },
      { url: "/services", label: "Car Service near Urbana jewels" },
      { url: "/services", label: "Car Service near Sunrise City" },
      { url: "/services", label: "Car Service near Dhanuka Sunshine Prime" },
      { url: "/services", label: "Car Service near Anukampa Platina" },
      { url: "/services", label: "Car Service near Royal Green City" },
    ],
    rederLinks = (tags) => {
      return tags.map((e, i) => {
        return (
          <Link href={e.url} title={e.label} key={i}>
            {e.label}
          </Link>
        );
      });
    },
    rederWords = (tags) => {
      return tags.map((e, i) => {
        return (
          <span className="link" title={e} key={i}>
            {e}
          </span>
        );
      });
    };
  return (
    <div className="sub-footer white">
      <div className="jumbo-container">
        <h2 className="heading-02  white">{t("popularSearches")}</h2>
        <section className="popular-service-section">
          <p>
            <span className="bold sub-head">{t("popularServices")}:</span>{" "}
            {rederLinks(service)}
          </p>
          <p>
            <span className="bold sub-head">{t("popularLocations")}:</span>{" "}
            {rederWords(searches)}
            {rederLinks(society)}
          </p>
        </section>
      </div>
    </div>
  );
};
